import { useEffect, useMemo } from "react";
import { API, TeamAPI, Factory } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { OrganizationsActions, OrganizationsState } from "../../reducers/OrganizationsSlice";
import {executeTypograf} from "../../utils/executeTypograf";

TeamAPI.GetPreview = Factory.createGetMethodExtended(TeamAPI, '/api/team/GetPreview');

const useExternalOrganization = (teamId: string, checkExisting?: boolean, shouldNotSaveTeam?: boolean, lite?: boolean) => {
  const dispatch = useDispatch();
  const { i18n: { language }} = useTranslation();
  const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);


  useEffect(() => {
    let preventLoading;
    
    if(shouldNotSaveTeam){
      dispatch(OrganizationsActions.clearOrganization())
    }
    if (storedTeam) {
      const { contextName, teamId: storedTeamId } = storedTeam;
      preventLoading = [contextName, storedTeamId].includes(teamId) && checkExisting
    }
    if (teamId && !preventLoading) {
      // const method = lite ? TeamAPI.GetPreview : TeamAPI.Get;
      TeamAPI.Get(({idTeam: teamId}))
        .then((res: any) => res.json())
        .then((res: any) => {
          if (res) {
            dispatch(OrganizationsActions.setFullOrganization(res))
          }
        })
    }
  }, [teamId, shouldNotSaveTeam])

  const getConvertButtons = (arr: any[]) => {

    const getCurrLangText = (langArr: any[]) => {

      const langObj = langArr?.find((i) => i?.lang === language);

      if (langObj?.name !== '') return langObj?.name

      return langArr?.find((m: any) => m?.name !== '')?.name || ''
    }

    return arr?.map((button) => {
      return {
        ...button,
        text: getCurrLangText(button?.text),
        textMobile: getCurrLangText(button?.textMobile),
        href: getCurrLangText(button?.href)
      }
    })
  }

  return useMemo(() => {
    const translatedTeam = API.toLang(storedTeam, language)
    if (!translatedTeam) return translatedTeam
    // @ts-ignore
    return {...translatedTeam, about: executeTypograf(translatedTeam?.about || ''), name: executeTypograf(translatedTeam?.name || ''), buttons: getConvertButtons(storedTeam?.buttons)}
  }, [storedTeam, language])
}

export default useExternalOrganization;import { useEffect, useMemo } from "react";
import { API, TeamAPI, Factory } from "@brg/api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { OrganizationsActions, OrganizationsState } from "../../reducers/OrganizationsSlice";
import {executeTypograf} from "../../utils/executeTypograf";

TeamAPI.GetPreview = Factory.createGetMethodExtended(TeamAPI, '/api/team/GetPreview');

const useExternalOrganization = (teamId: string, checkExisting?: boolean, shouldNotSaveTeam?: boolean, lite?: boolean) => {
  const dispatch = useDispatch();
  const { i18n: { language }} = useTranslation();
  const storedTeam = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);


  useEffect(() => {
    let preventLoading;
    
    if(shouldNotSaveTeam){
      dispatch(OrganizationsActions.clearOrganization())
    }
    if (storedTeam) {
      const { contextName, teamId: storedTeamId } = storedTeam;
      preventLoading = [contextName, storedTeamId].includes(teamId) && checkExisting
    }
    if (teamId && !preventLoading) {
      // const method = lite ? TeamAPI.GetPreview : TeamAPI.Get;
      TeamAPI.Get(({idTeam: teamId}))
        .then((res: any) => res.json())
        .then((res: any) => {
          if (res) {
            dispatch(OrganizationsActions.setFullOrganization(res))
          }
        })
    }
  }, [teamId, shouldNotSaveTeam])

  const getConvertButtons = (arr: any[]) => {

    const getCurrLangText = (langArr: any[]) => {

      const langObj = langArr?.find((i) => i?.lang === language);

      if (langObj?.name !== '') return langObj?.name

      return langArr?.find((m: any) => m?.name !== '')?.name || ''
    }

    return arr?.map((button) => {
      return {
        ...button,
        text: getCurrLangText(button?.text),
        textMobile: getCurrLangText(button?.textMobile),
        href: getCurrLangText(button?.href)
      }
    })
  }

  return useMemo(() => {
    const translatedTeam = API.toLang(storedTeam, language)
    if (!translatedTeam) return translatedTeam
    // @ts-ignore
    return {...translatedTeam, about: executeTypograf(translatedTeam?.about || ''), name: executeTypograf(translatedTeam?.name || ''), buttons: getConvertButtons(storedTeam?.buttons)}
  }, [storedTeam, language])
}

export default useExternalOrganization;